namespace AgerLMS.LMS {
    export interface DiscountsRow {
        Id?: number;
        Title?: string;
        DiscountType?: DiscountTypes;
        Source?: DiscountSourceTypes;
        ProductType?: DiscountProductTypes;
        Percentage?: number;
        MaxAmount?: number;
        MinimumOrder?: number;
        UsableTimes?: number;
        Coupon?: string;
        StartDate?: string;
        ExpiryDate?: string;
        OnlyFirst?: boolean;
        Description?: string;
        FixedAmount?: number;
        Courses?: number[];
        OrderedCourses?: number[];
        Categories?: number[];
        Groups?: number[];
        Users?: number[];
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace DiscountsRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'LMS.Discounts';
        export const deletePermission = 'LMS:Discount:Modify';
        export const insertPermission = 'LMS:Discount:Modify';
        export const readPermission = 'LMS:Discount:Read';
        export const updatePermission = 'LMS:Discount:Modify';

        export declare const enum Fields {
            Id = "Id",
            Title = "Title",
            DiscountType = "DiscountType",
            Source = "Source",
            ProductType = "ProductType",
            Percentage = "Percentage",
            MaxAmount = "MaxAmount",
            MinimumOrder = "MinimumOrder",
            UsableTimes = "UsableTimes",
            Coupon = "Coupon",
            StartDate = "StartDate",
            ExpiryDate = "ExpiryDate",
            OnlyFirst = "OnlyFirst",
            Description = "Description",
            FixedAmount = "FixedAmount",
            Courses = "Courses",
            OrderedCourses = "OrderedCourses",
            Categories = "Categories",
            Groups = "Groups",
            Users = "Users",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
